import { history } from '@umijs/max';
import { Button, Result } from 'antd';
import React from 'react';

const NoPermission: React.FC = () => (
  <Result
    status="403"
    title="403"
    subTitle="抱歉，您沒有權限訪問此頁面。"
    extra={
      <Button type="primary" onClick={() => history.push('/')}>
        回首頁
      </Button>
    }
  />
);

export default NoPermission;
